// Types and helpers shared by the teams tab (teams-tab.ts), its form (team-form.ts),
// and the single-group controls in the user/farm forms.
/**
 * Load the teams visible to the current user (admin → own one team, superadmin → all).
 * Soft-deleted groups are excluded — this list feeds every picker and filter, and a
 * deleted group must not be assignable. `withDeleted` (superadmin only) adds them back,
 * flagged, for the Teams tab's "Show deleted" view.
 */
export async function fetchTeams(withDeleted = false) {
    const res = await fetch(withDeleted ? '/api/teams?deleted=1' : '/api/teams');
    if (!res.ok)
        throw new Error('Failed to load teams');
    return (await res.json()).map(({ id, name, close_shift, deleted }) => ({ id, name, close_shift: !!close_shift, deleted: !!deleted }));
}
